// src/languages/i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './en';
import es from './es';
import fr from './fr';

i18n
  // Pasa el i18n a react-i18next
  .use(initReactI18next)
  // Detecta el idioma del usuario
  .use(LanguageDetector)
  // Inicializa i18next
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      fr: { translation: fr }
    },
    fallbackLng: 'en',
    debug: false, // Deshabilitar en producción

    interpolation: {
      escapeValue: false, // No es necesario con React
    },

    // Idiomas soportados
    supportedLngs: ['en', 'es', 'fr'],
  });

export default i18n;
